import { Component, OnInit } from '@angular/core';

import { FeedMetadataItem } from '../shared/models/feed-metadata-item.model';
import { FeedMetadataService } from '../shared/feed-metadata.service';
import { EventLoggerService } from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';

class Category {
    name: string;
    categoryOrdinal: number;
    categoryType: number;
    feeds: FeedMetadataItem[];
    feedProductType: number;
    isOpen: boolean;
}

@Component({
    selector: 'dm-feed-tree-nav',
    templateUrl: './feed-tree-nav.component.html',
    styleUrls: ['./feed-tree-nav.component.css']
})
export class FeedTreeNavComponent implements OnInit {
    categories: Category[];
    error: any;
    errorKey = 'feed-tree-nav';

    constructor(private feedMetadataService: FeedMetadataService, private eventLogger: EventLoggerService, private errorManager: ErrorManagerService) { }

    ngOnInit() {
        this.clearError();
        this.feedMetadataService.list().subscribe(
            feedMetadataItems => {
                if (feedMetadataItems) {
                    this.categories = [];
                    const cats = [] as Category[];
                    let curCategory: Category;
                    for (let i = 0; i < feedMetadataItems.length; i++) {
                        curCategory = null as Category;
                        const feed = feedMetadataItems[i];
                        const categoryName = feed.category;
                        const categoryOrdinal = feed.categoryOrdinal;
                        const feedProductType = feed.feedProductType;
                        for (let j = 0; j < cats.length; j++) {
                            const ct = cats[j];
                            if (ct.name === categoryName) {
                                curCategory = cats[j];
                                break;
                            }
                        }
                        if (curCategory) {
                            curCategory.feeds.push(feed);
                        } else {
                            curCategory = new Category();
                            curCategory.name = categoryName;
                            curCategory.categoryOrdinal = categoryOrdinal;
                            curCategory.feedProductType = feedProductType;
                            curCategory.feeds = [feed];
                            cats.push(curCategory);
                        }
                    }
                    for (let i = 0; i < cats.length; i++) {
                        cats[i].feeds = cats[i].feeds.sort((x, y) => x.name > y.name ? 1 : -1);
                    }
                    this.categories = cats.sort((x, y) => (x.categoryOrdinal + x.name) > (y.categoryOrdinal + y.name) ? 1 : -1);
                }
            },
            error => {
                this.error = error;
                this.handleError(error);
            }
        );
    }

    toggleCollapse(category: Category) {
        category.isOpen = !category.isOpen;
    }

    setActive(event: any, feedName: string) {
        event.stopPropagation();
    }

    clearError() {
        this.errorManager.removeDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey);
    }

    handleError(error: any) {
        const FeedTreeNoResponse = 'An unexpected error occurred. Please try again.';
        this.errorManager.saveDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey, error, FeedTreeNoResponse);
        this.eventLogger.logError(new Error(this.errorManager.dataMinerUiError.message), this.errorManager.dataMinerUiError.message, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-tree-nav/feed-tree-nav.component.ts